import block from './block.json';

export const buttonFilterThemeAttributes = {
	backgroundColor: '@tokens.variants.default.buttonBackgroundColor',
	minWidth: [100, 150],
	border: {
		color: '@tokens.variants.default.buttonBorderColor',
		width: {
			top: [1, 1],
			right: [1, 1],
			bottom: [1, 1],
			left: [1, 1],
		},
		radius: {
			topLeft: [20, 20],
			topRight: [20, 20],
			bottomRight: [20, 20],
			bottomLeft: [20, 20],
		},
	},
	padding: {
		top: [10, 15],
		right: [10, 15],
		bottom: [10, 15],
		left: [10, 15],
	},
	margin: {
		top: [10, 10],
		bottom: [10, 10],
		right: [10, 10],
	},
	title: {
		color: '@tokens.variants.default.buttonTitleColor',
		typography: '@tokens.typographies.button',
		textAlignment: 'left',
	},
	states: {
		hover: {}, // adds hover state
		active: {}, // adds active state
	},
};

export const ButtonFilterThemeControls = {
	// name of the block
	title: block.title,

	// slug of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: buttonFilterThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
